
import { Image, useScroll } from "@react-three/drei"
import { useFrame } from "@react-three/fiber"
import { useRef } from "react"
import { mainStore } from "../../store"


export default function ADN(props) {

    const group = useRef()

    const data = useScroll()

    const colors = mainStore.useStore(s => s.colors)


    useFrame(() => {
    })


    return <group ref={group} {...props}>
        <Image
            url={import.meta.env.BASE_URL + 'static/img/adn.webp'}
            transparent
            scale={3}
            zoom={0.7}
            segments={4}
            position={[1.7, 0, 1.4]}
            rotation={[0, 0, 0]}
            toneMapped={false}
            color={colors.clear}
        />

        <Image
            url={import.meta.env.BASE_URL + 'static/img/adn-underlay.webp'}
            transparent
            scale={3.2}
            zoom={0.75}
            segments={4}
            position={[1.5, -0.1, 1.33]}
            rotation={[0, 0, 0]}
            toneMapped={false}
            color={colors.clear}
        />

        <Image
            url={import.meta.env.BASE_URL + 'static/img/adn-bg.webp'}
            transparent
            scale={3.2}
            zoom={0.85}
            segments={4}
            position={[1.5, -0.1, 1.25]}
            rotation={[0, 0, 0]}
            toneMapped={false}
            color={colors.clear}
        />
    </group>
}